import { ComponentProps } from 'lib/component-props';
import ArticlesSectionComponent from 'components/Sections/RelatedArticlesVariations/ArticlesSectionComponent';
import React from 'react';
import { useI18n } from 'next-localization';
import { GetStaticComponentProps, useComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { defaultLanguage } from 'temp/config';
import { articleService } from 'lib/services/ArticleService';
import { ArticleCardData } from 'model/Article';
import RelatedArticleTile from 'components/Tiles/RelatedArticleTile';

const LatestArticlesSection = ({ rendering }: ComponentProps) => {
  const { t } = useI18n();
  const articles = useComponentProps<ArticleCardData[]>(rendering.uid);

  if (!articles?.length) return null;

  return (
    <ArticlesSectionComponent
      rendering={rendering}
      articles={articles}
      sectionTitle={t('latestArticlesTitle')}
      sliderCardComponent={RelatedArticleTile}
    />
  );
};

export const getStaticProps: GetStaticComponentProps = async (_rendering, layoutData) => {
  const siteId = layoutData.sitecore.context?.siteRoot;
  const language = layoutData.sitecore.context.language ?? defaultLanguage;
  return await articleService.getLatestArticles(language, siteId);
};

export default LatestArticlesSection;
